export default __webpack_public_path__ + "static/media/E_wdt_c_cap_1.4a02065a.mp3";